































import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Modal from '@/components/Modal/Modal.vue';
import SocialRewardsEmptyState from '@/componentsV2/organisms/SocialRewards/SocialRewardsEmptyState.vue';
import CampaignList from '@/componentsV2/organisms/SocialRewards/CampaignList.vue';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';
import SocialRewardsService from '@/api/SocialRewardsService';
import { SocialRewardCampaign } from '@/models/social-rewards';
import BillingModel from '../Models/BillingModel.vue';

const ALREADY_ACCESSED_SOCIAL_REWARDS =
  '@twism.already-accessed-social-rewards';

@Component({
  components: {
    Modal,
    SocialRewardsEmptyState,
    CampaignList,
    Page
  }
})
export default class SocialRewards extends BillingModel {
  socialRewardService = new SocialRewardsService();
  socialRewardsCampaigns: SocialRewardCampaign[] = [];
  isFirstAccess = true;
  loading = true;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get alreadyAccessedSocialRewards() {
    const storage = JSON.parse(
      localStorage.getItem(ALREADY_ACCESSED_SOCIAL_REWARDS) ||
        '{"value": false}'
    );

    return typeof storage === 'boolean'
      ? storage
      : storage.value && this.businessInfo.id === storage.id;
  }

  getSocialRewardsCampaigns() {
    return this.socialRewardService.getSocialRewardsCampaigns();
  }

  updateSocialRewardsCampaign(campaign: SocialRewardCampaign) {
    return this.socialRewardService.updateSocialRewardCampaign(campaign);
  }

  async init() {
    this.loading = true;
    try {
      const alreadyAccessedSocialRewards: boolean = this
        .alreadyAccessedSocialRewards;

      this.isFirstAccess = !alreadyAccessedSocialRewards;

      const {
        data: socialRewardsCampaigns
      } = await this.getSocialRewardsCampaigns();

      this.socialRewardsCampaigns = socialRewardsCampaigns;

      this.$store.dispatch(
        'socialRewards/SET_SOCIAL_CAMPAIGNS',
        socialRewardsCampaigns
      );

      this.isFirstAccess =
        !alreadyAccessedSocialRewards &&
        socialRewardsCampaigns &&
        socialRewardsCampaigns.length === 0;
    } finally {
      this.$hideLoader();
      this.loading = false;
    }
  }

  mounted() {
    this.$showLoaderWithLocker();
    this.init();
  }

  onClickGetStarted() {
    localStorage.setItem(
      ALREADY_ACCESSED_SOCIAL_REWARDS,
      JSON.stringify({ id: this.businessInfo.id, value: true })
    );
    this.isFirstAccess = false;
  }

  openModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'socialRewardsModal',
        false,
        true,
        true,
        true,
        true
      )
    );
  }

  async statusChanged(event: SocialRewardCampaign) {
    const index = this.socialRewardsCampaigns.findIndex(
      campaign => campaign.type === event.type
    );

    this.socialRewardsCampaigns.splice(index, 1, { ...event });

    this.$store.dispatch(
      'socialRewards/SET_SOCIAL_CAMPAIGNS',
      this.socialRewardsCampaigns
    );

    this.updateSocialRewardsCampaign(this.socialRewardsCampaigns[index]);
  }
}
